export default "__VITE_ASSET__0f52db9e__"